/**
 * @desc 裁剪后的spy工具
 * 文档：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/76YVMWYfJM/IyxPOPFmdj/u5if_ZaIawaCwp
 */

import SpyClient from './lib/spy-client';
import {isIOS, isAndroid} from './ua';

const spy = new SpyClient({
    pid: '31_153', // 必须
    lid: '', // 可选，页面的logid
    sample: 0.5, // 可选，默认为1, 全局抽样，取值：[0-1], 所有发送接口都受到该抽样，单个发送接口的sample配置会覆盖该抽样。
});

const dim = {
    os: isIOS() ? 'ios' : isAndroid() ? 'android' : 'unknown',
    page: window.location.pathname.split('/').slice(-1)[0] || 'unknown',
};

export const sendImmediate = (key: string, start?: number) => {
    const startT = start || performance.timing.navigationStart;

    // TTI结束点位置的代码
    const endT = Date.now();
    spy.sendPerf({
        group: 'h5',
        info: {[key]: endT - startT},
        dim,
    });
};

export const spyStart = () => {
    // spy.listenLCP((metric: any) => {
    //     spy.sendPerf({
    //         group: 'h5',
    //         info: metric,
    //         dim,
    //     });
    // });
    spy.listenTiming((metric: any) => {
        spy.sendPerf({
            group: 'h5',
            info: metric,
            dim,
        });
    });

    spy.listenResource(function (metric, hostMetric) {
        spy.sendPerf({
            group: 'h5',
            info: metric,
            dim,
        });
        // 分域名进行统计的
        // console.log('hostMetric', hostMetric);
    });

    spy.listenSlowResource(info => {
        spy.sendExcept({
            info: info,
            dim,
        });
    }, {threshold: 1000});

    // 数据类型：异常，触发时间：500MsAfterOnLoad
    spy.listenBigImg(info => {
        spy.sendExcept({
            info: info,
            dim,
        });
    });
};

export const sendExcept = (e: any, group: string = 'js_err') => {
    // 发送异常日志
    spy.sendExcept({
        info: {
            msg: e.msg, // msg字段是必须的，必须的，必须的，会统计相同msg的总量
            stack: e.stack || '',
            file: e.file || '',
        },
        group,
        dim,
    });
};

export default spy;
